import { Grid, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { useRef, useState } from 'react';
import Flatpickr from 'react-flatpickr';

import { useUnblockHoursDayRange } from '@/shared/actions/erp';
import { SingleButton } from '@/shared/components/ui';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { AlertSeverityEnum } from '@/shared/interfaces';
import { useAuthStore } from '@/store/auth';
import { usePlanificadorStore } from '@/store/erp';
import { useUiStore } from '@/store/ui';
import RangePickerPlanificador from './RangePickerPlanificador';
import { ROUTER_PATHS } from '@/shared';

export type CustomUnblockTimeModalProps = {
  planificadorId: string;
};

const CustomUnblockTimeModal: React.FC<CustomUnblockTimeModalProps> = ({
  planificadorId,
}) => {
  const flatpickrRef = useRef<Flatpickr | null>(null);
  const returnUrlPlanificadoresPage =
    ROUTER_PATHS.mantenimientoOperaciones.planificadorNav;
  ///* local state ----------------
  const [rangeDate, setRangeDate] = useState<Date[]>([]);

  ///* global state ----------------
  const isOpenCustomUnblockTime = usePlanificadorStore(
    s => s.isOpenCustomUnblockTime
  );
  const setIsOpenCustomUnblockTime = usePlanificadorStore(
    s => s.setIsOpenCustomUnblockTime
  );

  const handleRefreshPlanificador = usePlanificadorStore(
    s => s.handleRefreshPlanificador
  );

  const mondayToSunday = usePlanificadorStore(s => s.mondayToSunday);
  const user_id = useAuthStore(s => s.user?.user_id);
  const setAlert = useUiStore(s => s.setAlert);

  const selectedPlanificador = usePlanificadorStore(
    s => s.selectedPlanificador
  );

  const customErrorCallback = () => {
    //window.location.href = `${returnUrlPlanificadoresPage}/horario/${planificadorId}`;
  };

  ///* mutations -----------------
  const unblockHoursDayRange = useUnblockHoursDayRange({
    redirect: false,
    customErrorCallback,
  });

  ///* handlers ----------------
  const onSubmit = async () => {
    if (!rangeDate.length || rangeDate.length < 2) {
      setAlert(
        true,
        'El rango de fechas no puede estar vacío',
        AlertSeverityEnum.error
      );
      return;
    }

    const resp = await unblockHoursDayRange.mutateAsync({
      fecha_inicio: dayjs(rangeDate[0]).format('YYYY-MM-DD'),
      fecha_fin: dayjs(rangeDate[1]).format('YYYY-MM-DD'),
      user_id: user_id!,
      flota: selectedPlanificador?.flota_data?.codigo!,
    });

    handleClose();

    console.log(resp.data.at(0)?.time_map, 'unblock');
    

    handleRefreshPlanificador(resp.data.at(0)?.time_map!);
  };
  const onChangeRange = (days: Date[]) => {
    setRangeDate(days);
  };
  const handleClose = () => {
    setIsOpenCustomUnblockTime(false);
    //window.location.reload();

  };

  return (
    <>
      <ScrollableDialogProps
        open={isOpenCustomUnblockTime}
        title={'Desbloquear horario'}
        minWidth="30%"
        onClose={handleClose}
        // custom action buttons ------
        showCustomButtons
        customButtons={
          <>
            <SingleButton
              label="Desbloquear"
              onClick={onSubmit}
              variant="outlined"
            />
          </>
        }
        // content ------
        contentNode={
          <Grid item xs={12} container spacing={3} pt={2} pb={3}>
            <Grid item xs={12}>
              <Typography variant="h6">
                Selecciona los días a desbloquear:
              </Typography>
            </Grid>

            <RangePickerPlanificador
              flatpickrRef={flatpickrRef}
              onChange={onChangeRange}
              minDate={dayjs(mondayToSunday[0]).toDate()}
              maxDate={dayjs(mondayToSunday[1]).toDate()}
            />
          </Grid>
        }
      />
    </>
  );
};

export default CustomUnblockTimeModal;
